import {createAction} from '@reduxjs/toolkit';
import {Action} from 'redux';
import {appSessionStorage} from '~/shared/persistence';
import {LegacyAddressStatus} from '../AddressStatus';
import {userinfoRoutine} from '../userinfo/userinfoActions';
import {UserStatus} from '../UserStatus';

function getInitialState(): State {
    const authToken = appSessionStorage.authToken.get();
    const userStatus = appSessionStorage.authStatus.get();
    const addressStatus = appSessionStorage.addressStatus.get();

    return {
        userStatus: authToken ? userStatus : null,
        addressStatus: addressStatus,
        accessToken: authToken,
    };
}

type State = {
    userStatus: UserStatus | null;
    addressStatus: LegacyAddressStatus | null;
    accessToken: string | null;
};

/**
 * A crutch to force authReducer to re-read session storage
 */
export const sessionUpdated = createAction('auth/sessionUpdated', () => ({
    payload: getInitialState(),
}));

export function authReducer(state = getInitialState(), action: Action): State {
    if (userinfoRoutine.success.match(action)) {
        return {
            ...state,
            userStatus: action.payload.userStatus,
            addressStatus: action.payload.addressStatus,
        };
    }
    if (sessionUpdated.match(action)) {
        return {...state, ...action.payload};
    }
    return state;
}
